import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-chat-response-suggested-questions',
    templateUrl: './chat-response-suggested-questions.component.html',
    styleUrl: './chat-response-suggested-questions.component.scss',
})
export class ChatResponseSuggestedQuestionsComponent {
    @Input() suggestedQuestions: string[] = [];
    @Output() questionClick = new EventEmitter<string>();

    handleClick(question: string) {
        this.questionClick.emit(question);
    }

   
}
